var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebappCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#webapp_copy_svg__a)",
  stroke: "#2A46BD",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "m2.511 12.567-.065-.005a1.388 1.388 0 0 1-1.285-1.284 57.955 57.955 0 0 1 0-8.618 1.389 1.389 0 0 1 1.285-1.284 58.29 58.29 0 0 1 8.653 0c.688.05 1.234.596 1.285 1.284.076 1.042.125 2.062.147 3.076M8.181 18.403c-.881.39-1.863.403-2.615-.182a5.509 5.509 0 0 1-.967-.967c-.845-1.085-.443-2.65.54-3.699a52.243 52.243 0 0 1 2.663-2.663c1.049-.982 2.613-1.384 3.698-.539.363.283.684.604.967.967.35.45.486.98.456 1.523"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.404 8.356c.884-.402 1.863-.428 2.606.146.358.277.673.593.95.951.829 1.071.407 2.637-.587 3.697a54.282 54.282 0 0 1-2.693 2.693c-1.06.994-2.626 1.416-3.697.587a5.278 5.278 0 0 1-.95-.95c-.342-.442-.471-.967-.435-1.507"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "webapp_copy_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgWebappCopy;